import styled, { css } from 'styled-components';
import { grayDarker, grayLight, white } from '@bufferapp/ui/style/colors';

export const MediaThumbnailWrapper = styled.div`
  position: relative;
  overflow: hidden;
  justify-self: flex-end;
  ${(props) =>
    props.size !== 'extraSmall' &&
    css`
      border: 1px solid ${grayLight};
      border-radius: 2px;
    `}
  ${(props) =>
    props.size === 'small' &&
    css`
      width: 38px;
      height: 38px;
    `}
  ${(props) =>
    props.size === 'medium' &&
    css`
      width: 78px;
      height: 78px;
    `}
  ${(props) =>
    props.size === 'large' &&
    css`
      width: 98px;
      height: 98px;
    `}
  ${(props) =>
    props.size === 'extraSmall' &&
    css`
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      width: 30px;
      height: 30px;
    `};
`;

export const Media = styled.img`
  filter: ${(props) => (props.hasMediaThumbnail ? 'brightness(0.75)' : 'none')};
  object-fit: cover;
  ${(props) =>
    props.size === 'extraSmall' &&
    css`
      max-width: 30px;
    `}
  ${(props) =>
    props.size === 'small' &&
    css`
      max-width: 38px;
    `}
  ${(props) =>
    props.size === 'medium' &&
    css`
      max-width: 80px;
    `}
`;

export const MediaIconWrapper = styled.div`
  position: absolute;
  height: 16px;
  ${(props) =>
    props.size !== 'extraSmall' &&
    css`
      bottom: 4px;
      left: 4px;
    `}
  ${(props) =>
    props.size === 'extraSmall' &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
  ${(props) =>
    props.size === 'large' &&
    css`
      border-radius: 50%;
      background-color: ${grayDarker};
      display: block;
      height: 32px;
      width: 32px;
      line-height: 40px;
      text-align: center;
    `}
`;

export const ReelsTagWrapper = styled.div`
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 14px;
  height: 16px;
  border-radius: 5px;
  background-color: ${grayDarker};
  color: ${white};
  display: block;
  height: 18px;
  width: 56px;
  line-height: 18px;
  text-align: center;
`;
